var exports = {
  "kL": "xdbfd91f1--dd73b3--container",
  "e3": "xdbfd91f1--dd73b3--image_container",
  "nr": "xdbfd91f1--dd73b3--fat_panel",
};

module.exports = exports;
